import { atom } from "jotai";
import { observe } from "jotai-effect";

import type { DisplayEvent } from "@/utils/event-helpers";

import { currentUserIdAtom } from "@/atoms/session";
import { fetchAllEvents } from "@/utils/event-queries";

export const eventsAtom = atom<DisplayEvent[] | null>(null);
export const eventsLoadingAtom = atom(true);

export const refreshEventsAtom = atom(null, async (_get, set) => {
  set(eventsLoadingAtom, true);
  try {
    const events = await fetchAllEvents();
    set(eventsAtom, events);
  } finally {
    set(eventsLoadingAtom, false);
  }
});

observe((get, set) => {
  get(currentUserIdAtom);
  set(refreshEventsAtom);
});
